// extracted by mini-css-extract-plugin
module.exports = {"n1fcwfbc":"n1fcwfbc"};